import { render } from "./SponsorGallery.vue?vue&type=template&id=bb2c3f1c&scoped=true"
import script from "./SponsorGallery.vue?vue&type=script&lang=js"
export * from "./SponsorGallery.vue?vue&type=script&lang=js"

import "./SponsorGallery.vue?vue&type=style&index=0&id=bb2c3f1c&scoped=true&lang=scss"

import exportComponent from "/builds/threatinformant/conference/exploit-marketing-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb2c3f1c"]])

export default __exports__